import { wrapRef } from '../../../../../data';
import useReference from '../../../../../hooks/use_reference';

const ShingleList = props => {
  if (props === undefined) {
    return [];
  }

  const reference = wrapRef('Cms::DataProvider', {
    dataset: 'shingles',
    parameters: {
      zip: props.zip,
      c_code: props.address.country_code,
      lang: props.locale.code,
    },
  });
  const { results } = useReference(reference);

  return results?.data || [];
};

export default ShingleList;
